import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
// import '../../Style/EditModal.scss';
// import "../../Style/TableStyle.scss"
// import '../../Style/__searchbar.scss'
// import '../../Style/__button.scss'
// import '../../Style/AccountingBooks.scss';
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { AiOutlineFileExcel } from "react-icons/ai";
import { SiHyperledger } from "react-icons/si";
import "jspdf-autotable";
import { Month } from '../../OtherData/Month'
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { errorAlert, infoAlert } from "../../Components/Alerts";
import { TaxSalesExcelForm } from "../../Print/TaxSalesExcelForm";
import { TaxSalesExcelFormNoVAT } from "../../Print/TaxSalesExcelFormNoVAT";
import DataGridComponent from "../../Components/DataGridComponent";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import { AddActionsButton, AddElementsButton } from "../../Components/AddElementsButton";

const currencyFormatter = new Intl.NumberFormat('en-US', {
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});


export default function TaxSalesBook() {
    const [data, setData] = useState([]);
    const headers = authHeader();

    const [month, setMonth] = useState(0);
    const [ngaData, setNgaData] = useState("");
    const [deriData, setDeriData] = useState("");
    const { fiscalYear } = useContext(FiscalYearContext);

    const [minDate, setMinDate] = useState('');
    const [maxDate, setMaxDate] = useState('');

    useEffect(() => {
        setMinDate(`${fiscalYear}-01-01`);
        setMaxDate(`${fiscalYear}-12-31`);
    }, [fiscalYear])


    const [showMonthFilter, setShowMonthFilter] = useState(true);

    const openDateFilter = () => {
        setShowMonthFilter(false);
        setMonth(0);
        setData([]);
    }
    const openMonthFilter = () => {
        setShowMonthFilter(true);
        setNgaData("");
        setDeriData("");
        setData([]);
    }

    const [vatDeclarant, setVatDeclarant] = useState(true);


    const [dataNoVAT, setDataNoVAT] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [tm, setTm] = useState("");

    const allTM = [
        {
            id: 1,
            title: "TM1",
            firstDate: `01/01/${fiscalYear}`,
            lastDate: `03/31/${fiscalYear}`
        },
        {
            id: 2,
            title: "TM2",
            firstDate: `04/01/${fiscalYear}`,
            lastDate: `06/30/${fiscalYear}`
        },
        {
            id: 3,
            title: "TM3",
            firstDate: `07/01/${fiscalYear}`,
            lastDate: `09/30/${fiscalYear}`
        },
        {
            id: 4,
            title: "TM4",
            firstDate: `10/01/${fiscalYear}`,
            lastDate: `12/31/${fiscalYear}`
        }
    ]

    function formatDate(date) {
        if (!date) return '';

        // Parse the date string into a Date object if it's not already one
        const d = (date instanceof Date) ? date : new Date(date);

        // Format the date components
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0'); // January is 0!
        // const year = d.getFullYear();

        return `${day}/${month}/${fiscalYear}`;
    }

    const handleDownloadExcel = () => {
        const workbook = TaxSalesExcelForm(data);
        workbook.xlsx.writeBuffer().then(buffer => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);

            // Krijo një element për shkarkim
            const a = document.createElement('a');
            a.href = url;

            (month === 0 ?
                a.download = `LSH_Periudha nga_${formatDate(ngaData)}_Deri_${formatDate(deriData)}.xlsx` :
                a.download = `LSH_${month}_${fiscalYear}.xlsx`
            )


            a.click();
            URL.revokeObjectURL(url);
        });
    };


    const handleDownloadExcelNoVAT = () => {
        const workbook = TaxSalesExcelFormNoVAT(dataNoVAT);
        workbook.xlsx.writeBuffer().then(buffer => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);

            // Krijo një element për shkarkim
            const a = document.createElement('a');
            a.href = url;
            a.download = `LSH_TM${tm}_${fiscalYear}.xlsx`

            a.click();
            URL.revokeObjectURL(url);
        });
    };

    const params = {};

    if (month && month >= 1 && month <= 12) {
        params.month = month;
        params.fiscalYear = fiscalYear;
    } else if (ngaData && deriData) {
        params.firstDate = ngaData;
        params.secondDate = deriData;
    }

    // const [showDataSms, setShowDataSms] = useState("")
    const fetchData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'TaxReport/salesbook', { headers, params });
            setData(response.data);
            // setLoading(false);
        } catch (error) {
            if (error.response && error.response.status === 400) {
                // Kthehet nga serveri për mungesë qasje
                infoAlert("Ju nuk keni qasje në këto të dhëna.");
                // setShowDataSms("Ju nuk keni qasje në këto të dhëna.");
            } else {
                errorAlert("Gabim në kërkesë:", error);

                if (error.response && error.response.data && error.response.data.errorMessage) {
                    errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
                } else if (error.message) {
                    errorAlert(`Gabim: ${error.message}`);
                } else {
                    errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
                }
            }
        }
    };
    const fetchdataNoVAT = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'TaxReport/salesbooknovat', { headers, params: { firstDate: startDate, secondDate: endDate } });
            setDataNoVAT(response.data);
            // setLoading(false);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const handleChange = (event) => {
        const selectedId = event.target.value;
        const selectedTM = allTM.find((tm) => tm.id === selectedId);
        if (selectedTM) {
            setStartDate(selectedTM.firstDate);
            setEndDate(selectedTM.lastDate);
            // Thirr fetchdataNoVAT pasi të përditësohen datat për startDate dhe endDate
            fetchdataNoVAT();
        }

    };

    useEffect(() => {
        if (ngaData && ngaData !== "" && deriData && deriData !== "") {
            fetchData();
        }
    }, [ngaData, deriData, fiscalYear]);

    const fetchCompaniesData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Companies/getCompanyDetails', { headers });
            // setCompaniesData(response.data);
            // setLoading(false);
            // setLogoPath(ApiLink.PHOTO_URL + response.data[0].CompanyLogo);
            setVatDeclarant(response.data[0].VATDeclarant);

            // console.log(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const columns = [
        { field: 'id', headerName: '#', width: 110, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
        { field: 'date', headerName: 'Data Fatures', type: 'string', width: 130, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
        { field: 'nr', headerName: 'Numri Faturës', width: 210, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
        { field: 'klienti', headerName: 'Emri Bleresit', width: 210, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
        { field: 'nui', headerName: 'Numri Identifikues', width: 210, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
        { field: 'vat', headerName: 'Numri i TVSH-së', width: 210, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
        {
            field: 'SHPK', headerName: 'Shitjet Pa Kreditim', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
        },

        {
            field: 'SHSH', headerName: 'Shitjet Sherbimeve', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
            hide: !vatDeclarant, // Fsheh kolonën nëse vatDeclarant nuk është true

        },
        {
            field: 'SHMNK', headerName: 'Shitjet Me Ngarkese Te_Kundert', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
            hide: !vatDeclarant, // Fsheh kolonën nëse vatDeclarant nuk është true
        },

        {
            field: 'SHLMK', headerName: 'Shitjet Liruara Me Kreditim', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
            hide: !vatDeclarant, // Fsheh kolonën nëse vatDeclarant nuk është true
        },

        {
            field: 'TSHLMK', headerName: 'Total Shitjet Liruara Me Kreditim', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
            hide: !vatDeclarant, // Fsheh kolonën nëse vatDeclarant nuk është true
        },

        {
            field: 'eksportet', headerName: 'Eksportet', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
            hide: !vatDeclarant, // Fsheh kolonën nëse vatDeclarant nuk është true
        },

        {
            field: 'SH18', headerName: 'Shitjet 18', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
            hide: !vatDeclarant, // Fsheh kolonën nëse vatDeclarant nuk është true
        },

        {
            field: 'ND18', headerName: 'Nota Debitore 18', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
            hide: !vatDeclarant, // Fsheh kolonën nëse vatDeclarant nuk është true
        },

        {
            field: 'BK18', headerName: 'Borgji Keq 18', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
            hide: !vatDeclarant, // Fsheh kolonën nëse vatDeclarant nuk është true
        },

        {
            field: 'RR18', headerName: 'Rregullimet 18', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
            hide: !vatDeclarant, // Fsheh kolonën nëse vatDeclarant nuk është true
        },

        {
            field: 'NK18', headerName: 'Ngarkesa Kundert 18', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
            hide: !vatDeclarant, // Fsheh kolonën nëse vatDeclarant nuk është true
        },
        {
            field: 'TV18', headerName: 'Total VAT 18', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
            hide: !vatDeclarant, // Fsheh kolonën nëse vatDeclarant nuk është true
        },

        {
            field: 'SH8', headerName: 'Shitjet 8', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
            hide: !vatDeclarant, // Fsheh kolonën nëse vatDeclarant nuk është true
        },

        {
            field: 'ND8', headerName: 'Nota Debitore 8', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
            hide: !vatDeclarant, // Fsheh kolonën nëse vatDeclarant nuk është true
        },

        {
            field: 'BK8', headerName: 'Borgji Keq 8', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
            hide: !vatDeclarant, // Fsheh kolonën nëse vatDeclarant nuk është true
        },

        {
            field: 'RR8', headerName: 'Rregullimet 8', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
            hide: !vatDeclarant, // Fsheh kolonën nëse vatDeclarant nuk është true
        },

        {
            field: 'TV8', headerName: 'Total VAT 8', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
            hide: !vatDeclarant, // Fsheh kolonën nëse vatDeclarant nuk është true
        },

        {
            field: 'TVAT8_18', headerName: 'Total TVSH 8 dhe 18', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
            hide: !vatDeclarant, // Fsheh kolonën nëse vatDeclarant nuk është true
        },
    ];

    const columnsNoVAT = [
        { field: 'id', headerName: '#', width: 110, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
        { field: 'date', headerName: 'Data Fatures', type: 'string', width: 130, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
        { field: 'nr', headerName: 'Numri Faturës', width: 210, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
        { field: 'invType', headerName: 'Lloji transaksionit', width: 210, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
        { field: 'type', headerName: 'Import/Export', width: 210, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
        { field: 'klienti', headerName: 'Emri Bleresit', width: 210, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
        { field: 'nui', headerName: 'Numri Identifikues', width: 210, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
        {
            field: 'SHMBV', headerName: 'Shitje e mallrave / shërbimeve brenda vendit', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
        },

        {
            field: 'SHSHJV', headerName: 'Shitje e shërbimeve jashtë vendit', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
            hide: !vatDeclarant, // Fsheh kolonën nëse vatDeclarant nuk është true

        },
        {
            field: 'eksport', headerName: 'Eksporte', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
            hide: !vatDeclarant, // Fsheh kolonën nëse vatDeclarant nuk është true
        },

        {
            field: 'total', headerName: 'Shitje Totale', type: 'string', width: 110, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
            valueFormatter: (value) => {
                if (!value) {
                    return value;
                }
                return currencyFormatter.format(value);
            },
            hide: !vatDeclarant, // Fsheh kolonën nëse vatDeclarant nuk është true
        },
    ];

    const rows = data.map((item) => ({
        id: item.Nr,
        date: item.DataFatures || 0,
        nr: item.NumriFatures || 0,
        klienti: item.EmriBleresit || 0,
        nui: item.IdentificationNumber || 0,
        vat: item.VATNumber || 0,
        SHPK: item.Shitjet_Pa_Kreditim || 0,
        SHSH: item.Shitjet_Sherbimeve || 0,
        SHMNK: item.Shitjet_Me_Ngarkese_Te_Kundert || 0,
        SHLMK: item.Shitjet_Liruara_Me_Kreditim || 0,
        TSHLMK: item.Total_Shitjet_Liruara_Me_Kreditim || 0,
        eksportet: item.Eksportet || 0,
        SH18: item.Shitjet18 || 0,
        ND18: item.NotaDebitore18 || 0,
        BK18: item.BorgjiKeq18 || 0,
        RR18: item.Rregullimet18 || 0,
        NK18: item.NgarkesaKundert18 || 0,
        TV18: item.TotalVAT18 || 0,
        SH8: item.Shitjet8 || 0,
        ND8: item.NotaDebitore8 || 0,
        BK8: item.BorgjiKeq8 || 0,
        RR8: item.Rregullimet8 || 0,
        TV8: item.TotalVAT8 || 0,
        TVAT8_18: item.Total_TVSH_8_dhe_18 || 0,

        // className: item.Balance === 0 ? 'zero-balance-row' : 'non-zero-balance-row', // Shto klasën CSS bazuar në vlerën e 'balance'
    }));

    const rowsNoVAT = dataNoVAT.map((item) => {
        // Llogarit totalin e vlerave për ShitjeVendore, EksporteSherbimeve dhe EksporteProdukteve
        const total = (parseFloat(item.ShitjeVendore) || 0) + (parseFloat(item.EksporteSherbimeve) || 0) + (parseFloat(item.EksporteProdukteve) || 0);

        // Kthe objektin me të dhënat e përpunuara dhe totalin e shtuar
        return {
            id: item.Nr,
            date: item.Date || 0,
            nr: item.ActionType === 'IND' ? `IND-${fiscalYear}-${item.InvoiceNr}` : item.InvoiceNr || 0,
            invType: item.ActionType || 0,
            type: item.TransactionType || 0,
            klienti: item.AccountName || 0,
            nui: item.IdentificationNumber || 0,
            SHMBV: item.ShitjeVendore || 0,
            SHSHJV: item.EksporteSherbimeve || 0,
            eksport: item.EksporteProdukteve || 0,
            total: total.toString(), // Vendos totalin në objekt
        };
    });



    useEffect(() => {
        fetchData();
        fetchCompaniesData();
        fetchdataNoVAT();
    }, [month, startDate, endDate, fiscalYear]);

    return (
        <div className="TaxButtons__Container">
            <TitleElements
                icon={SiHyperledger}
                title="Libri i Shitjes për ATK"
            />
            <ElementsParagraph text="Ky format i librit të shitjeve është i përshtatur për ngarkim në sistemin e ATK-së." />
            <div className="TaxButtons__Container__Body">
                <div className="TaxButtons__Container__SearchSection">
                    <div className="TaxButtons__Container__SearchSection__PDF">
                        {
                            vatDeclarant ?
                                <>
                                    <AddActionsButton
                                        text="XLSX"
                                        onClick={handleDownloadExcel}
                                        icon={<AiOutlineFileExcel />}
                                        className="button-15"
                                    />
                                </>
                                :
                                <>
                                    <AddActionsButton
                                        text="XLSX"
                                        onClick={handleDownloadExcelNoVAT}
                                        icon={<AiOutlineFileExcel />}
                                        className="button-15"
                                    />
                                </>
                        }
                    </div>

                    <div className="TaxButtons__Container__SearchSection__Search">
                        {
                            vatDeclarant ?
                                <>
                                    <div className="TaxButtons__Container__SearchSection__Search__Btn">
                                        {
                                            showMonthFilter ? (
                                                // <button className="button-15" onClick={openDateFilter}>Filtro sipas datave</button>
                                                <AddElementsButton
                                                    text="Filtro sipas datave"
                                                    onClick={openDateFilter}
                                                    // icon="bi bi-upc-scan"
                                                    className="button-15"
                                                />
                                            ) : (
                                                <>
                                                    {/* <button className="button-15" onClick={openMonthFilter}>Filtro sipas Muajit</button> */}
                                                    <AddElementsButton
                                                        text="Filtro sipas Muajit"
                                                        onClick={openMonthFilter}
                                                        // icon="bi bi-upc-scan"
                                                        className="button-15"
                                                    />
                                                </>
                                            )
                                        }
                                    </div>
                                    <div className="TaxButtons__Container__SearchSection__Search__Input">
                                        {
                                            showMonthFilter ? (
                                                <TextField
                                                    className="TaxButtons__Container__SearchSection__Search__Input__Month"
                                                    id=""
                                                    select
                                                    label="Përzgjedh muajin"
                                                    value={month}
                                                    onChange={event => {
                                                        setMonth(event.target.value);
                                                        fetchData();
                                                    }}
                                                    required
                                                >
                                                    {Month.map((data) => (
                                                        <MenuItem key={data.id} value={data.id}>
                                                            {fiscalYear}{data.month}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            ) : (
                                                <div>
                                                    <TextField
                                                        style={{ marginLeft: "5px" }}
                                                        id="date"
                                                        type="date"
                                                        variant="outlined"
                                                        name='Date'
                                                        label="Nga"
                                                        value={ngaData}
                                                        onChange={(e) => { setNgaData(e.target.value); }}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        inputProps={{
                                                            min: minDate, // Kufizimi minimal i datës
                                                            max: maxDate, // Kufizimi maksimal i datës
                                                        }}
                                                    />
                                                    <TextField
                                                        style={{ marginLeft: "5px" }}
                                                        id="date"
                                                        type="date"
                                                        variant="outlined"
                                                        name='Date'
                                                        label="Deri"
                                                        value={deriData}
                                                        onChange={(e) => { setDeriData(e.target.value); }}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        inputProps={{
                                                            min: minDate, // Kufizimi minimal i datës
                                                            max: maxDate, // Kufizimi maksimal i datës
                                                        }}
                                                    />
                                                </div>

                                            )
                                        }
                                    </div>
                                </> :
                                <div className="TaxButtons__Container__SearchSection__Search__Input">
                                    <TextField
                                        className="TaxButtons__Container__SearchSection__Search__Input__Month"
                                        id=""
                                        select
                                        label="Përzgjedh 3-Mujorin"
                                        value={tm}
                                        onChange={(e) => { handleChange(e); setTm(e.target.value) }}
                                        required
                                    >
                                        {allTM.map((data) => (
                                            <MenuItem key={data.id} value={data.id}>
                                                {data.title}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </div>
                        }
                    </div>
                </div>
            </div>
            <hr></hr>
            {
                vatDeclarant ?
                    <DataGridComponent columns={columns} rows={rows} />
                    :
                    <DataGridComponent columns={columnsNoVAT} rows={rowsNoVAT} />
            }
        </div>
    )
}